export default __webpack_public_path__ + "static/media/AchrafAtoini.5217bdda.webp";